import billingCreator from './creator';

export default billingCreator;
